var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-backdrop left-0 fade modal",
      attrs: {
        id: "go-modal-notice-systemUpgrade",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-notice" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src: "content/images/goover-event-250716-seminar-popup-1.jpg",
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticStyle: { cursor: "pointer" },
              attrs: {
                src: "content/images/goover-event-250716-seminar-popup-btn.jpg",
              },
              on: { click: _vm.redirect },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.dontDisplayToday()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("button.dont-display-today")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary",
                attrs: { type: "button", "data-dismiss": "modal" },
              },
              [_vm._v(_vm._s(_vm.$t("button.close")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }